import React from "react"
import { inject, observer } from "mobx-react"
import { NextSeo } from "next-seo"
import TrafficSubmissionFlow from "~/pages/traffic-tickets/flow"

const CaliforniaTrafficTicketsPage = () => {
  return (
    <>
      <NextSeo
        title="California Traffic Tickets | WinIt"
        description="Looking for an experienced lawyer to fight your California traffic ticket? Use the Winit app and find the best CA traffic lawyers."
        canonical="https://www.appwinit.com/california-traffic-tickets"
        additionalMetaTags={[
          {
            property: "description",
            content:
              "Looking for an experienced lawyer to fight your California traffic ticket? Use the Winit app and find the best CA traffic lawyers.",
          },
        ]}
      />
      <TrafficSubmissionFlow />
    </>
  )
}

export default inject((all) => ({
  selectedState: all.store.trafficSubmission.selectedState,
}))(observer(CaliforniaTrafficTicketsPage))
